import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { withStyles, TextField, Button, InputAdornment, CircularProgress } from '@material-ui/core'
import i18n from 'support/i18n'
import NxtVirtualCurrency from 'components/nxt_virtual_currency'
import style from './View.Style'

class InvestSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorLabel: '',
      investmentAmount: '',
      showErrorRange: false,
    }
    this.handleInvestChange = this.handleInvestChange.bind(this)
    this.renderInputLabel = this.renderInputLabel.bind(this)
    this.handleInvestButtonClick = this.handleInvestButtonClick.bind(this)
  }

  handleInvestChange(event) {
    const { maxInvestment, minInvestment, userBalance } = this.props
    const { value } = event.target
    let showErrorRange = false
    let errorLabel = ''

    if (!value) {
      this.setState({
        investmentAmount: value,
        showErrorRange,
        errorLabel,
      })
      return
    }
    const amount = parseInt(value, 10)

    if (amount < minInvestment || Number.isNaN(amount)) {
      showErrorRange = true
      errorLabel = i18n.t('EXPLORE_IDEA.INVALID_AMOUNT')
    } else if (amount > maxInvestment && amount <= userBalance) {
      showErrorRange = true
      errorLabel = i18n
        .t('EXPLORE_IDEA.ERROR_INVESTING_MAX_ALLOWED')
        .replace('##AMOUNT##', maxInvestment)
    } else if (amount > userBalance) {
      showErrorRange = true
      errorLabel = i18n.t('EXPLORE_IDEA.NOT_ENOUGH_FOUND_INVEST')
    }

    this.setState({
      investmentAmount: value,
      showErrorRange,
      errorLabel,
    })
  }

  handleInvestButtonClick() {
    const { onInvestButtonClick } = this.props
    const { investmentAmount } = this.state
    onInvestButtonClick(investmentAmount)
    this.setState({
      investmentAmount: '',
    })
  }

  renderInputLabel() {
    const { currencyIcon, minInvestment, maxInvestment } = this.props
    const { errorLabel } = this.state
    if (errorLabel.length) {
      return <span>{errorLabel}</span>
    }
    return (
      <span>
        MIN:
        <span className={`icon-${currencyIcon}`} />
        &nbsp;
        {minInvestment} - MAX: <span className={`icon-${currencyIcon}`} /> &nbsp;
        <NxtVirtualCurrency>{maxInvestment}</NxtVirtualCurrency>
      </span>
    )
  }

  render() {
    const { investmentAmount, showErrorRange } = this.state
    const {
      classes,
      currencyIcon,
      isInvestmentInProcess,
      maxInvestment,
      helpText,
      inProcessButtonText,
      buttonText,
      shouldInputBeDirty,
      customIdeaTitle
    } = this.props

    const reButtonText = customIdeaTitle === "" ? buttonText : buttonText.replace("idea", customIdeaTitle)
    const reInProcessButtonText = customIdeaTitle === "" ? inProcessButtonText : inProcessButtonText.replace("idea", customIdeaTitle)

    return (
      <div className={classes.root}>
        {helpText && <span className={classes.helpText}>{helpText}</span>}
        {maxInvestment > 0 && (
          <TextField
            error={showErrorRange}
            label={this.renderInputLabel()}
            type="number"
            value={investmentAmount}
            InputLabelProps={{ shrink: true }}
            onChange={this.handleInvestChange}
            margin="normal"
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <span className={`icon-${currencyIcon}`} />
                </InputAdornment>
              ),
            }}
          />
        )}
        <Button
          variant="contained"
          color="primary"
          disabled={
            showErrorRange ||
            (shouldInputBeDirty && investmentAmount.length === 0) ||
            maxInvestment === 0
          }
          onClick={this.handleInvestButtonClick}
        >
          {isInvestmentInProcess ? reInProcessButtonText : reButtonText}
          {isInvestmentInProcess && <CircularProgress size={24} color="secondary" />}
        </Button>
      </div>
    )
  }
}

InvestSection.defaultProps = {
  helpText: '',
  customIdeaTitle: ''
}

InvestSection.propTypes = {
  userBalance: PropTypes.number.isRequired,
  maxInvestment: PropTypes.number.isRequired,
  minInvestment: PropTypes.number.isRequired,
  currencyIcon: PropTypes.string.isRequired,
  onInvestButtonClick: PropTypes.func.isRequired,
  isInvestmentInProcess: PropTypes.bool.isRequired,
  shouldInputBeDirty: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
  inProcessButtonText: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  customIdeaTitle: PropTypes.string,
}

export default withStyles(style)(InvestSection)
